export const ERROR_REASONS = {
	SUCCESS: "Success",
	EXIST: "Exist",
	EMAIL_EXISTS: "EmailExists",
	NOT_FOUND: "NotFound",
	NOT_CREATED: "NotCreated",
	NOT_SAVED: "NotSaved",
	IMPERMISSIBLE_TYPE: "ImpermissibleType",
	DUPLICATE: "Duplicate",
	NOT_ALLOWED: "NotAllowed",
	LIMIT_EXCEEDED: "LimitExceeded",
	FILE_NOT_FOUND: "FileNotFound",
	WRONG_TOKEN: "WrongToken",
	WRONG_LOGIN_PARAMETERS: "WrongLoginParameters",
	UNAUTHORIZED: "Unauthorized",
	DONT_HAVE_PERMISSION: "DontHavePermission",
	NOT_ENOUGH_BALANCE: "NotEnoughBalance",
	INVALID_PARAMETERS: "InvalidParameters",
	INTERNAL_SERVER_ERROR: "InternalServerError",
	INVALID_REDEMPTION_DATE: "InvalidRedemptionDate",
	ATTEMPS_LIMIT_REACHED: "AttempsLimitReached",
	PASSWORD_EXPIRED: "PasswordExpired",
	NOT_AVAILABLE: "NotAvailable",
	USED_PASSWORD: "UsedPassword",
	INVALID_CAPTCHA: "InvalidCaptcha",
	INVALID_SIGN: "InvalidSign",
	INVALID_PROJECT: "InvalidProject",
	ALREADY_LOGGED: "AlreadyLogged",
	MAINTENANCE_MODE_ON: "MaintenanceModeOn",
	EXPIRED: "Expired",
	USED: "Used",
	NOT_SENT: "NotSent",
	PERMANENT_LOCKED: "PermanentLocked",
	TEMPORARY_LOCKED: "TemporaryLocked",
	DEACTIVATED: "Deactivated"
};

export const ERROR_MESSAGES = {
	BLOCKED: "Blocked",
	GUID_NOT_FOUND: "Guid Not Found!",
	GAME_NOT_FOUND: "Game Not Found!",
	INVALID_PLAYED_DATA: "InvalidPlayedData",
	NOT_SUPPORTED_CURRENCY: "NotSupportedCurrency",
	INVALID_PLAYER_CURRENCY: "InvalidPlayerCurrency",
	IMPERMISSIBLE_EVENT_STATE: "Impermissible Event state.",
	PLAYER_SETTINGS_INVALID_PARAMETER: "Player_Settings InvalidParameters"
};

export const ERROR_RESOURCES = {
	NONE: "None",
	ALL: "All",
	PARTNER: "Partner",
	PARTNER_CURRENCY: "Partner_Currency",
	PARTNER_GENERAL_INFO: "Partner_GeneralInfo",
	PARTNER_ONLINE_SETTINGS: "Partner_OnlineSettings",
	PARTNER_RETAIL_SETTINGS: "Partner_RetailSettings",
	PARTNER_SECURITY_SETTINGS: "Partner_SecuritySettings",
	PARTNER_LANGUAGE: "Partner_Language",
	PARTNER_WALLET: "Partner_Wallet",
	USER: "User",
	USER_TOKEN: "User_Token",
	USER_AUTHENCATOR_QR: "User_AuthencatorQR",
	USER_NOTIFICATION: "User_Notification",
	USER_PERMISSIONS: "User_Permissions",
	USER_REQUEST: "User_Request",
	PERMISSION: "Permission",
	PERMISSION_GROUP: "Permission_Group",
	PERMISSION_REQUESTS: "Permission_Requests",
	GAME: "Game",
	GAME_SCENE: "Game_Scene",
	GAME_PROBABILITY: "Game_Probability",
	GAME_GENERAL_INFO: "Game_GeneralInfo",
	GAME_RTP: "Game_RTP",
	GAME_BANNER: "Game_Banner",
	GAME_CYCLE_MINUTES: "Game_Cycle_Minutes",
	API_KEY: "ApiKey",
	API_KEY_GENERAL_INFO: "ApiKey_GeneralInfo",
	API_KEY_CURRENCY: "ApiKey_Currency",
	API_KEY_GAME: "ApiKey_Game",
	API_KEY_GAME_RTP: "ApiKey_Game_RTP",
	API_KEY_GAME_OTHER_CONFIGS: "ApiKey_Game_OtherConfigs",
	API_KEY_RESTRICTED_COUNTRY: "ApiKey_RestrictedCountry",
	API_KEY_RESTRICTED_IP: "ApiKey_RestrictedIP",
	PENDING_BETS: "PendingBets",
	SETTLED_BETS: "SettledBets",
	BOX: "Box",
	BOX_GAME: "Box_Game",
	BOX_GAME_RTP: "Box_Game_RTP",
	BET_SHOP: "BetShop",
	BET_SHOP_CURRENCY: "BetShop_Currency",
	BET_SHOP_BOX: "BetShop_Box",
	BET_SHOP_BOX_GAME: "BetShop_BoxGame",
	BET_SHOP_OPERATING_SETTINGS: "BetShop_OperatingSettings",
	BET_SHOP_WALLET: "BetShop_Wallet",
	BETSHOP_REPORT: "Betshop_Report",
	BETSHOP_BONUS: "Betshop_Bonus",
	BETSHOP_BONUS_VOUCHER: "Betshop_BonusVoucher",
	SESSION: "Session",
	PLAYER: "Player",
	PLAYER_GEO_LOCATION: "Player_GeoLocation",
	PLAYER_SETTINGS: "Player_Settings",
	PLAYER_BONUS: "Player_Bonus",
	PLAYER_CURRENCY: "Player_Currency",
	PLAYER_DEVICE: "Player_Device",
	PLAYER_BROWSER: "Player_Browser",
	EVENT: "Event",
	WEEK: "Week",
	ODD: "Odd",
	MARKET: "Market",
	BET_SLIP: "BetSlip",
	BET_SLIP_EVENT: "BetSlip_Event",
	BET_SLIP_BET: "BetSlip_Bet",
	JOB: "Job",
	SYSTEM_ODD: "SystemOdd",
	SYSTEM_COUNTRY: "SystemCountry",
	SYSTEM_CURRENCY: "SystemCurrency",
	SYSTEM_LANGUAGE: "SystemLanguage",
	SYSTEM_COUNTER: "SystemCounter",
	CASHIER: "Cashier",
	TRANSLATION: "Translation",
	TRANSLATION_GROUP: "Translation_Group",
	TRANSLATION_SUB_GROUP: "Translation_SubGroup",
	OPERATOR: "Operator",
	FILE: "File",
	BET_TRANSACTION: "BetTransaction",
	TRANSACTION: "Transaction",
	RACE_PARTICIPANT: "RaceParticipant",
	HOT_KEY: "HotKey",
	TICKET: "Ticket",
	USER_LOGS: "UserLogs",
	SYSTEM_LOG: "SystemLog",
	BET: "Bet",
	CAPTCHA: "Captcha",
	RSS_FEED: "RssFeed",
	SETTINGS: "Settings",
	SETTINGS_MAINTENENACE_MODE: "Settings_MaintenenaceMode",
	SETTINS_OPERATOR: "Settins_Operator",
	SURVEY: "Survey",
	SURVEY_GENERAL_INFO: "Survey_GeneralInfo",
	FEEDBACK: "Feedback",
	STREAM: "Stream",
	PAYMENT_TYPE: "PaymentType",
	EMAIL: "Email",
	RULE: "Rule",
	STREAM_SERVER: "StreamServer",
	STREAM_SERVER_GAME: "StreamServer_Game",
	NOTIFICATION: "Notification",
	CUSTOM: "Custom",
	JACKPOT_SETTING: "Jackpot_Setting",
	JACKPOT_TRANSACTION: "Jackpot_Transaction",
	BIG_MULTIPLIER_CONFIGURATION: "BigMultiplier_Configuration",
	BIG_MULTIPLIER_ACTIVITY: "BigMultiplier_Activity",
	BET_ANOMALY_CONFIGURATION: "BetAnomaly_Configuration",
	BET_ANOMALY_ACTIVITY: "BetAnomaly_Activity",
	SUSPICIOUS_ACTIVITY: "SuspiciousActivity",
	SUSPICIOUS_ACTIVITY_CONFIGURATION: "SuspiciousActivity_Configuration"
};

export const RESPONSE_STATE = {
	SUCCESS: "Success",
	UNAUTHORIZED: "Unauthorized",
	MAINTENANCE_MODE: "MaintenanceModeOn"
};


export const REQUEST_ABORT_CODE = "ERR_CANCELED";